export class ApplicationUrls {
  MerchantAppLink!: string;
  BGVerificationAppLink!: string;
  ContosoUniLink!: string;
}
